<template>
  <div class="preloader" v-if="isLoading">
    <span class="preloader__spinner far fa-spinner fa-spin" />
  </div>

  <splitpanes watch-slots class="default-theme" v-else-if="isAccessGranted">
    <vis-entity-type-mnemonics-tree
      @select="onSelect"
      :splitpanes-size="30"
      ref="tree"
    />
    <div v-if="crudService != null" class="detail-view h-100">
      <vis-toolbar
        v-if="detailViewToolbar"
        :items="detailViewToolbar"
        for="detail-view"
      ></vis-toolbar>
      <div
        class="k-virtual-content vis-has-toolbar ba--mt-4 ba-pt-4 ba-overflow-x-auto"
      >
        <vis-entity-type-detail-view
          detail-view-state="layout"
          :crud-service="crudService"
          :context="context"
          :key="repaintKey"
          @save="onDetailViewSave"
          @toolbarChanged="onDetailViewToolbarChanged"
        ></vis-entity-type-detail-view>
      </div>
    </div>
    <div v-else class="bg-white" :splitpanes-size="70" />
  </splitpanes>

  <div v-else>{{ $t("accessDenied")}}</div>
</template>
<script>
import splitpanes from "splitpanes";

import api from "@/api/visary-api"
import VisEntityTypeMnemonicsTree from "./vis-entity-type-mnemonics-tree";
import NodeTypes from "./js/node-types";
import RemoteCrudService from "@/shared/services/remote-crud-service";
import VisEntityTypeDetailView from "@/views/base/custom-editors/vis-entity-type-detail-view";

export default {
  name: "vis-entity-type-master-detail-view",
  components: {
    splitpanes,
    VisEntityTypeMnemonicsTree,
    VisEntityTypeDetailView
  },
  data() {
    return {
      selectedItem: null,
      context: {},
      crudService: null,
      detailViewToolbar: [],
      isAccessGranted: false,
      isLoading: false,
      repaintKey: 0
    };
  },

  created() {
    this.checkAccess()
  },

  methods: {
    onDetailViewSave(e) {
      this.crudService.setId(e.model.ID);
      this.$refs.tree.updateEntity(e.model);
    },
    onDetailViewToolbarChanged(toolbar) {
      this.detailViewToolbar = toolbar;
    },
    async setCrudService(mnemonic) {
      this.crudService = new RemoteCrudService(mnemonic);
      const model = this.selectedItem.original;
      const id = model.ID;
      if (mnemonic === "MnemonicEntity") {
        this.context.mnemonic = model.Mnemonic;
        this.crudService.addDefaultValue("Mnemonic", model.Mnemonic);
      }
      if (id > 0) {
        this.crudService.setId(id);
      } else {
        this.crudService.setId(0);
        if (mnemonic === "AssemblyInfo") {
          this.crudService.addDefaultValue("Name", model.Name);
        }
      }
      this.updateDetailView()
    },
    onSelect: function (item) {
      this.selectedItem = item;
      this.crudService = null;
      switch (item && item.nodeType) {
        case NodeTypes.assembly:
          this.setCrudService("AssemblyInfo");
          break;
        case NodeTypes.entityType:
          if (item.original.IsDynamic) {
            this.setCrudService("DynamicEntityTypeInfo");
          } else {
            this.setCrudService("EntityTypeInfo");
          }
          break;
        case NodeTypes.mnemonic:
          this.setCrudService("MnemonicEntity");
          break;
        default:
          break;
      }
    },
    updateDetailView() {
      this.repaintKey++
    },
    async checkAccess() {
      this.isLoading = true

      this.isAccessGranted = await api.user.checkPathAccess({ path: this.$route.path })

      this.isLoading = false
    },
  },
};
</script>

